// Panel d'envoi d'une notification push à un segment d'utilisateurs.
// Segments : all / pro / starter / free / inactive30.
// Le formulaire empêche l'envoi sans confirmation explicite.
import React, { useState } from "react";
import { adminBroadcast } from "../services/authService";

const SEGMENTS = [
	{ key: "all", label: "Tous les utilisateurs", desc: "Diffusion générale" },
	{ key: "pro", label: "Abonnés Pro", desc: "Uniquement les Pro actifs" },
	{ key: "starter", label: "Abonnés Starter", desc: "Uniquement les Starter actifs" },
	{ key: "free", label: "Comptes gratuits", desc: "Users sans abonnement actif" },
	{ key: "inactive30", label: "Inactifs 30 jours+", desc: "Aucune séance modifiée depuis 30 jours (réactivation)" },
];

export default function AdminBroadcastPanel() {
	const [segment, setSegment] = useState("all");
	const [title, setTitle] = useState("");
	const [body, setBody] = useState("");
	const [sending, setSending] = useState(false);
	const [result, setResult] = useState(null);
	const [error, setError] = useState("");

	const canSend = title.trim().length > 0 && body.trim().length > 0 && !sending;

	const handleSend = async () => {
		const seg = SEGMENTS.find((s) => s.key === segment);
		const msg = `Envoyer la notification "${title}" à "${seg.label}" ?\n\nContenu :\n${body}`;
		if (!window.confirm(msg)) return;

		setSending(true);
		setError("");
		setResult(null);
		const r = await adminBroadcast({ segment, title: title.trim(), body: body.trim() });
		setSending(false);
		if (r.success) {
			setResult(r);
			setTitle("");
			setBody("");
		} else {
			setError(r.error || "Erreur");
		}
	};

	return (
		<div className="admin-broadcast-panel">
			<p style={{ color: "var(--ink-soft)", fontSize: 14, margin: "0 0 20px" }}>
				Envoie une notification push à un segment d'utilisateurs. La notification apparaît
				directement sur leur téléphone (même app fermée).
			</p>

			<div className="admin-broadcast-section">
				<label className="group-settings-label">Destinataires</label>
				<div className="admin-broadcast-segments">
					{SEGMENTS.map((s) => (
						<button
							key={s.key}
							type="button"
							className={`admin-broadcast-segment ${segment === s.key ? "selected" : ""}`}
							onClick={() => setSegment(s.key)}
						>
							<span className="admin-broadcast-segment-label">{s.label}</span>
							<span className="admin-broadcast-segment-desc">{s.desc}</span>
						</button>
					))}
				</div>
			</div>

			<div className="admin-broadcast-section">
				<label className="group-settings-label" htmlFor="broadcast-title">
					Titre (max 100 caractères)
				</label>
				<input
					id="broadcast-title"
					type="text"
					value={title}
					onChange={(e) => setTitle(e.target.value)}
					maxLength={100}
					placeholder="Nouvelle version disponible !"
					className="admin-broadcast-input"
				/>
				<div className="admin-broadcast-count">{title.length} / 100</div>
			</div>

			<div className="admin-broadcast-section">
				<label className="group-settings-label" htmlFor="broadcast-body">
					Message (max 300 caractères)
				</label>
				<textarea
					id="broadcast-body"
					value={body}
					onChange={(e) => setBody(e.target.value)}
					maxLength={300}
					rows={3}
					placeholder="Découvre les nouvelles fonctionnalités..."
					className="admin-broadcast-input"
				/>
				<div className="admin-broadcast-count">{body.length} / 300</div>
			</div>

			{error && <div className="mens-modal-error">{error}</div>}
			{result && (
				<div className="admin-broadcast-result">
					✓ Envoi terminé : {result.pushes} push{result.pushes > 1 ? "es" : ""} envoyée{result.pushes > 1 ? "s" : ""}
					{" "}à {result.targets} utilisateur{result.targets > 1 ? "s" : ""}.
				</div>
			)}

			<div className="admin-broadcast-actions">
				<button
					className="mens-btn primary"
					onClick={handleSend}
					disabled={!canSend}
				>
					{sending ? "Envoi en cours..." : "Envoyer la notification"}
				</button>
			</div>
		</div>
	);
}
